"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = require("../button");

var _notification = require("./notification.styled");

var _box = require("../box");

var _checkThin = _interopRequireDefault(require("../../icons/check-thin"));

var _warning = _interopRequireDefault(require("../../icons/warning"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notification = function Notification(props) {
  var id = props.id,
      type = props.type,
      title = props.title,
      buttonTitle = props.buttonTitle;
  return /*#__PURE__*/_react.default.createElement(_notification.NotificationStyled, {
    $type: type,
    id: id,
    buttonTitle: buttonTitle
  }, type === 'error' ? /*#__PURE__*/_react.default.createElement(_warning.default, {
    color: "white"
  }) : /*#__PURE__*/_react.default.createElement(_checkThin.default, {
    color: "white"
  }), /*#__PURE__*/_react.default.createElement(_box.Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-live": "polite",
    role: type === 'error' ? 'alert' : 'status'
  }, title), buttonTitle && /*#__PURE__*/_react.default.createElement(_button.Button, {
    onClick: props.onClickButton
  }, props.buttonTitle)));
};

exports.Notification = Notification;
Notification.displayName = 'Notification';
Notification.Style = _notification.NotificationStyled;